<template>
  <Modal :value="value" @hide="hide()" title="Computer details">
    <template slot="body" class="content">
      <table class="table is-hoverable is-fullwidth">
        <tr>
          <td>Computer name</td>
          <td>{{ computer.name }}</td>
        </tr>
        <tr>
          <td>Online</td>
          <td :class="{ 'has-text-success': computer.online }">
            {{ computer.online ? "Yes" : "No" }}
          </td>
        </tr>
        <tr>
          <td>Online changed</td>
          <td>
            <span v-if="computer.onlineChanged">{{
              toIso(computer.onlineChanged)
            }}</span>
          </td>
        </tr>
        <tr>
          <td>DP version</td>
          <td>{{ computer.clientVersion }}</td>
        </tr>
        <tr>
          <td>System storage type</td>
          <td>
            <span v-if="computer.systemInfo">
              {{ computer.systemInfo.systemDiskType == "SSD" ? "SSD" : "HDD" }}
            </span>
          </td>
        </tr>
        <tr>
          <td>Free system space</td>
          <td>
            <span
              v-if="computer.systemInfo"
              :class="
                ({
                  'has-text-danger':
                    computer.systemInfo.freeSystemDiskSpace < 0.5
                },
                {
                  'has-text-warning':
                    computer.systemInfo.freeSystemDiskSpace < 7
                })
              "
              >{{ computer.systemInfo.freeSystemDiskSpace }} GB</span
            >
          </td>
        </tr>

        <tr>
          <td>RAM (total)</td>
          <td>
            <span v-if="computer.systemInfo && computer.systemInfo.ramTotal"
              >{{ parseAndRound(computer.systemInfo.ramTotal) }} GB</span
            >
          </td>
        </tr>

        <tr>
          <td>OS build</td>
          <td>{{ computer.systemInfo.osVersion }}</td>
        </tr>

        <tr>
          <td>
            IP
          </td>
          <td>
            {{ computer.systemInfo.localIp }}
          </td>
        </tr>

        <tr>
          <td>MAC</td>
          <td>
            <span
              v-for="macAddress of computer.systemInfo.macAddresses"
              :key="macAddress"
              >{{ macAddress }},
            </span>
          </td>
        </tr>
      </table>
    </template>
    <template slot="footer" class="content">
      <div class="button" @click="hide()">Close</div>
    </template>
  </Modal>
</template>
<script>
import computerHelper from "@/utils/computer";
import { parseAndRound } from "@/utils/string";
import { fromNow, toReadable } from "@/utils/date";

export default {
  props: {
    value: Boolean,
    computer: Object
  },
  components: {
    Modal: () => import("@/components/main/Modal.vue")
  },
  computed: {
    parseAndRound() {
      return str => {
        return parseAndRound(str);
      };
    },
    name() {
      return computer => {
        return computerHelper.getName(computer);
      };
    },
    fromNow() {
      return date => {
        return fromNow(date);
      };
    },
    toIso() {
      return date => {
        return toReadable(date);
      };
    }
  },
  data() {
    return {};
  },

  methods: {
    hide() {
      this.$emit("hide", false);
      this.$emit("input", false);
    }
  }
};
</script>
